import moment from 'moment';
import { Transaction, TransactionFilters } from '../types';

export const groupTransactions = (transactionsList: Transaction[]) => {
  return transactionsList.reduce(
    (acc: Record<string, Transaction[]>, transaction: Transaction) => {
      const date = transaction.created.split(' ')[0];
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(transaction);
      return acc;
    },
    {},
  );
};

export const formatDate = (
  date: Date | string,
  pattern?: { input?: string; output?: string },
): string => moment(date, pattern?.input).format(pattern?.output || 'DD-MM-YYYY');

export const getFilterName = ({
  t,
  filter,
}: {
  t: (descriptor: object, values?: any) => string;
  filter: TransactionFilters;
}) => {
  switch (filter) {
    case TransactionFilters.IN:
      return t({ id: 'transactions.filter.in' });
    case TransactionFilters.HOLD:
      return t({ id: 'transactions.filter.hold' });
    case TransactionFilters.OUT:
      return t({ id: 'transactions.filter.out' });
    case TransactionFilters.PENDING:
      return t({ id: 'transactions.filter.pending' });
    case TransactionFilters.QUERY:
      return 'Query';
  }
};

export const getTypeName = (type: string) => {
  return '';
};
